<form [formGroup]="formGroup" class="grid-container">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12">
      To begin, please select a type of submission from the following options:
    </div>
    <label class="cell large-3" [ngClass]="{ 'red': moduleInvalid, 'bold': moduleInvalid }" for="selModule">Submission: * </label>

    @if (availableModules) {
      <select class="cell large-9" id="selModule" formControlName="selectedModule" (change)="validateForm()">
        @for (mod of availableModules; track mod) {
          <option [value]="mod.id">
            {{mod.title}}
          </option>
        }
      </select>
    }
    @if (!availableModules) {
      <div class="cell large-9">
        <text-loader [run]="availableModules == null" [text]="'Loading Submissions'" [tickType]="'.'" [interval]="1000"></text-loader>
      </div>
    }
    <label class="cell large-3" [ngClass]="{ 'red': typeInvalid, 'bold': typeInvalid }" for="selApp">Submission Type: * </label>
    <select class="cell large-9" id="selApp" formControlName="selectedApplication" (change)="validateForm()">
      @for (app of availableApplications; track app) {
        <option [value]="app.id">
          {{app.title}}
        </option>
      }
    </select>
    <div class="cell large-12 text-align-right">
      <button class="button margin-right" (click)="cancel()">Cancel</button><button class="button" (click)="advance()" [disabled]="formGroup.invalid">Next</button>
    </div>
  </div>
</form>